/**
 * 공통 데이터 포맷팅 유틸리티
 * 성능 최적화를 위해 formatter를 재사용합니다.
 */

// 퍼센트 포맷터 (소수점 2자리)
export const percentFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// 숫자 포맷터 (소수점 2자리)
export const numberFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// 화폐 포맷터 (달러, 소수점 없음)
export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

// 화폐 포맷터 (달러, 소수점 2자리)
export const currencyFormatterWithCents = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * 날짜를 짧은 형식으로 포맷 (MM-DD)
 */
export function formatDateTick(value: string | number): string {
  const dateString = String(value);
  return dateString.slice(5, 10);
}

/**
 * 값을 달러 형식으로 포맷 (소수점 없음)
 */
export function formatValueTick(value: number): string {
  return `$${value.toFixed(0)}`;
}

/**
 * 퍼센트 틱 포맷 (소수점 1자리)
 */
export function formatPercentTick(value: number): string {
  return `${value.toFixed(1)}%`;
}

/**
 * 툴팁 라벨을 로케일 날짜 형식으로 포맷
 */
export function formatTooltipLabel(label: string | number): string {
  const parsed = new Date(label);
  if (!Number.isNaN(parsed.valueOf())) {
    return parsed.toLocaleDateString();
  }
  return String(label);
}

/**
 * 퍼센트 값 포맷 (소수점 2자리 + % 기호)
 */
export function formatPercent(value: number): string {
  return `${percentFormatter.format(value)}%`;
}

/**
 * 화폐 값 포맷 (달러)
 */
export function formatCurrency(value: number): string {
  return currencyFormatter.format(value);
}

/**
 * 화폐 값 포맷 (달러, 소수점 2자리)
 */
export function formatCurrencyWithCents(value: number): string {
  return currencyFormatterWithCents.format(value);
}
